import * as React from "react";

const Alert = ({ children }) => <div className="alert alert-danger alert-dismissable">{children}</div>;

export default Alert;
